// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_COMMENT = "Pridaj koment\u00e1r";
export const BLOGS_POST_FORM_ONE_OF_COMMENT_PHOTO_OR_STICKER_IS_REQUIRED = "Pr\u00e1zdnu spr\u00e1vu nem\u00f4\u017ee\u0161 odosla\u0165";
export const SEND_AS_ADMIN = "oznam Modr\u00e9ho kon\u00edka";
export const SEND_COMMENT = "Odo\u0161li koment\u00e1r";
